<template>
	<div>
		<PageHeader>
			<StatisticsLinkList />
		</PageHeader>
		<ManagingSection :isTable="true">
			<HorizontalSearch :blockElem="true" @init="init" @search="search">
				<SelectInput
					ref="period"
					label="기간"
					:usePeriod="true"
					@change="periodChange"
				/>
				<RadioList
					v-model="type"
					:radioList="typeList"
					ver="3"
					title="목록 종류"
				/>
				<template v-slot:optionalButton="{ className }">
					<button
						:class="['btn-excel', className]"
						v-text="'EXCEL 다운로드'"
						@click="excelDown"
					/>
				</template>
			</HorizontalSearch>
		</ManagingSection>
		<ManagingSection :isTable="true">
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th" v-text="th" />
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="idx">
						<td v-text="item.date" />
						<td v-text="item.registerCnt" />
						<td v-text="item.missionRegisterCnt" />
						<td v-text="item.missionReviewCnt" />
						<td v-text="item.commentCnt" />
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import moment from 'moment';
	import Excel from 'exceljs';
	import PageHeader from '@/components/PageHeader.vue';
	import StatisticsLinkList from '@/components/operation/StatisticsLinkList.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import RadioList from '@/components/RadioList.vue';

	export default {
		name: 'AttendanceStatistics',
		components: {
			PageHeader,
			StatisticsLinkList,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			RadioList,
		},
		data() {
			return {
				start: null,
				end: null,
				typeList: [
					{ id: 'd', value: '일별' },
					{ id: 'm', value: '월별' },
					{ id: 'y', value: '년별' },
				],
				type: null,
				thList: [
					'기간',
					'참여자수',
					'미션 참여자수',
					'미션 리뷰 등록수',
					'댓글',
				],
				list: [],
				reqUrl: '',
			};
		},
		methods: {
			periodChange({ from, to }) {
				this.start = from;
				this.end = to;
			},
			setFilter({ start, end, type } = {}) {
				this.$refs.period.changePeriod({
					from: start || moment().date(1).format('YYYY-MM-DD'),
					to: end || moment().format('YYYY-MM-DD'),
				});
				this.type = this.typeList.some(item => item.id === type)
					? type
					: this.typeList[0].id;
			},
			setQuery() {
				const query = {
					start: this.start,
					end: this.end,
					type: this.type,
				};
				this.$router.replace({ query }).catch(() => {});
			},
			async setList() {
				try {
					const type = this.type;
					const params = (this.params = {
						start: this.start,
						end: this.end,
						type,
					});
					const {
						data: { stampSummary },
						config: { url: reqUrl },
					} = await this.$axiosAdmin2.get('/v3/api/stamp/summary', {
						params,
					});
					this.list = stampSummary.map(item => ({
						...item,
						date: moment(item.stampedDate, 'YYYYMMDD').format(
							type === 'y'
								? 'YYYY'
								: type === 'm'
									? 'YYYY-MM'
									: 'YYYY-MM-DD'
						),
					}));
					this.reqUrl = reqUrl;
				} catch (err) {
					console.error(err);
					alert('리스트를 불러오는데 실패했습니다.');
				}
			},
			search() {
				this.setList();
				this.setQuery();
			},
			async excelDown() {
				const workbook = new Excel.Workbook();

				workbook.creator = '글로우픽';
				workbook.lastModifiedBy = '글로우픽';
				workbook.created = new Date();
				workbook.modified = new Date();
				const sheet = workbook.addWorksheet('one');
				sheet.columns = this.thList.map((th, idx) => ({
					header: th,
					key: idx,
				}));
				sheet.addRows(
					this.list.map(item => [
						item.date,
						item.registerCnt,
						item.missionRegisterCnt,
						item.missionReviewCnt,
						item.commentCnt,
					])
				);

				const typeName = this.typeList.find(
					({ id }) => id === this.params.type
				).value;
				const data = await workbook.xlsx.writeBuffer();
				const blob = new Blob([data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				const url = window.URL.createObjectURL(blob);
				const anchor = document.createElement('a');
				anchor.href = url;
				anchor.download = `글로우픽_출석체크 ${typeName} 통계(${this.params.start} ~ ${this.params.end})_${new Date().getTime()}.xlsx`;
				anchor.click();
				window.URL.revokeObjectURL(url);

				const params = {
					admin_log: {
						path: this.$router.currentRoute.fullPath,
						action: 'CSV',
						doc: { 'api-url': this.reqUrl },
					},
				};
				await this.$axiosSupport.post('/admin/admin_log', params);
			},
			init() {
				this.setFilter();
				this.search();
			},
		},
		mounted() {
			this.setFilter(this.$route.query);
			this.setList();
		},
	};
</script>
<style lang="scss" scoped></style>
